// extracted by mini-css-extract-plugin
export default {"inputRequire":"v3Xq9Q4GBmTMedFuwb2w","require":"yJCix1iB8TJSGMTy1ybE","common_bganimation":"AGpd33ihBO3Q2vI7O1VQ"};